/**
 * core/gallery/frontend.js
 * 
 * @author jjarolim
 */

import $ from 'jquery'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

/**
 * Helper functions
 */

const initializeSwiper = () => {

    const params = {

        modules: [ Navigation ],

        // Defaults

        autoWidth: true,
        grabCursor: true,
        initialSlide: 1,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        speed: 1000,

        // Navigation

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

    }

    /* Initialize Cover-Slider Swiper && Magnificent Popup */

    for ( const element of document.querySelectorAll( '.is-style-swiperjs-slide' ) ) {

        const swiper = new Swiper( element.querySelector( '.swiper' ), params );

        /*$( element ).magnificPopup( {
            delegate: '.wp-block-image a',
            type: 'image'
        } );*/


    }

}

initializeSwiper();